/**
 * $.uiScrollbar() plugin.
 *
 * Options:
 *     $wrapper: jQuery object              - Custom jQuery object for $.uiScrollbar().
 *     theme: String (optional)             - Theme for scrollbar.
 *     scrollbar_options: Object (optional) - Scrollbar options
 */
(function ($) {
    var UIScrollbar = (function ($) {

        UIScrollbar = function (options) {
            var that = this;

            that.class = {
                default_theme: 'scrollbar'
            };

            that.$wrapper = options['$wrapper'];
            that.$wrapper_parent = that.$wrapper.parent();

            //
            that.theme = options['theme'] || that.class.default_theme;
            that.scrollbar_options = options['scrollbar_options'] || {};
            that.disable_tab_focus = (typeof options['disable_tab_focus'] === 'boolean' ? options['disable_tab_focus'] : true);

            //
            that.scrollbar = null

            that.init();
        };

        UIScrollbar.prototype.init = function () {
            var that = this;

            if (that.disable_tab_focus) {
                that.$wrapper.attr('tabindex', '-1');
            }

            that.scrollbar = that.$wrapper.addClass(that.theme).scrollbar(that.scrollbar_options);
            
            that.$wrapper.data('uiScrollbar', that);
        };

        UIScrollbar.prototype.destroy = function () {
            var that = this;

            that.scrollbar = that.$wrapper.removeClass(that.theme).scrollbar('destroy');
        };

        return UIScrollbar;

    })($);

    $.uiScrollbar = function ($wrapper, theme = null, scrollbar_options = {}) {
        var options = $.extend(true, {}, {$wrapper: $wrapper, theme: theme, scrollbar_options: scrollbar_options});
        return new UIScrollbar(options);
    };

})(jQuery);
